import React, { FunctionComponent } from 'react'

type Props = {
  handleSubmit: () => void
  submitting: boolean
  ctaText: string | undefined
}

const SubmitButton: FunctionComponent<Props> = ({
  handleSubmit,
  submitting,
  ctaText = '',
}) => {
  return (
    <div className="w-full flex justify-center mt-2">
      <button
        className="bg-primary py-3 rounded text-white flex justify-center w-4/5 md:w-3/5 mx-auto my-4 items-center"
        onClick={handleSubmit}
      >
        <p className="pr-2 md:text-font16 font-bold">
          {submitting ? 'SAVING...' : ctaText}
        </p>
        {!submitting && (
          <img
            src= {`${process.env.CDN_URL}/assets/icons/practice_tab/whitearrow.svg`}
            className="scale-125"
          />
        )}
      </button>
    </div>
  )
}
export default SubmitButton
